<template>
  <div class="table_wrap pb10">
    <div class="el-table list-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition el-table__body-wrapper is-scrolling-none">
      <div class="">
        <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;" class="el-table__header">
          <colgroup>
            <col width="">
            <col width="">
            <col width="">
          </colgroup>
          <thead class="has-gutter">
          <tr>
            <th class="is-leaf list-header">
              <div class="cell">고정 게시글</div>
            </th>
            <th class="is-leaf list-header">
              <div class="cell">수정일</div>
            </th>
            <th class="is-leaf list-header">
              <div class="cell">옵션</div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <div class="cell text-center">
                <div style="width: 250px; display: inline-block;">
                  <el-radio-group v-model="hasFixBoard" style="display: block;" class="ma10" @change="changeFixType">
                    <el-radio :label="1" :value="1" v-if="hasFixBoard===1">게시글 고정</el-radio>
                    <el-radio :label="0" :value="0">고정 없음</el-radio>
                  </el-radio-group>
                  <div v-if="fixBoard === null || hasFixBoard===0"  class="short inline-block mr10">
                    <el-button @click="openSelectItem()" >
                      등록
                    </el-button>
                  </div>
                  <div v-else class="short inline-block mr10">
                    <el-button @click="openSelectItem()" >
                      변경
                    </el-button>
                  </div>
                  <div class="short inline-block" v-if="hasFixBoard===1 && fixBoard !== null">
                    {{fixBoard.wr_subject}}
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="cell text-center">
                <div v-if="fixBoard != null && hasFixBoard===1"  style="width: 250px; display: inline-block;">
                   {{returnUpdateDate(fixBoard.updated_at)}}
                </div>
              </div>
            </td>
            <board-fix-create-btn-component v-if="bidData === ''" :bidProps="bidData" :boardType="createType" :hasFixBoard="hasFixBoard" :fixBoard="fixBoard"></board-fix-create-btn-component>
            <board-fix-update-btn-component v-else :bidProps="bidData" :boardType="updateType" :hasFixBoard="hasFixBoard" :fixBoard="fixBoard"></board-fix-update-btn-component>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import dateMixins from "@/mixins/dateMixins";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import boardTemplateUtil from "@/components/board/boardTemplateUtil";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import BoardFixCreateBtnComponent from "@/components/board/BoardFixCreateBtnComponent";
import BoardFixUpdateBtnComponent from "@/components/board/BoardFixUpdateBtnComponent";


const { filterConfig } = boardFilterUtil;
export default {
  name: "BoardFixComponent",
  mixins: [
    alertMixins,
    filterMixins,
    listMixins,
    dateMixins,
    boardFilterUtil,
    boardTemplateUtil,
  ],
  components: {BoardFixCreateBtnComponent, BoardFixUpdateBtnComponent},
  inject: ["changeLoading"],
  provide() {
    return {
    };
  },

  props: {
    boardType: "",
    userKey: "",
    ssamsKey: "",
    updateType: "",
    createType: "",
    modalType : ""
  },
  data() {
    return {
      listLayout: "",
      listApiParamSet: {},
      filterLayout: "",
      paginationLayout: "",
      paginationType: "",
      getFunc: "",
      deleteFunc: "",
      deleteApiParamsSet: {},
      deleteSuccessType: 1,
      deleteFailTypes: {},
      deleteErrorTypes: [],
      keyName: "",
      selectArr: [],
      DeleteClass: null,
      deleteIndex: 0,
      deleteLastIndex: 0,
      filterDate: "",
      filterSort: false,
      parsingData : {},
      fixBoard : null,
      hasFixBoard : 0,
      bidData : "",
    };
  },
  created() {
    this.initConfig();
  },
  mounted() {
    EventBus.$on( `${this.boardType}setSelectOneModalData`, this.selectFixData);
    // EventBus.$on( `setSelectOneModalData`, this.selectFixData);
    EventBus.$on('getBoardFixData', this.initConfig)
  },
  beforeDestroy() {
    EventBus.$off(`${this.boardType}setSelectOneModalData`)
    // EventBus.$off(`setSelectOneModalData`)
    EventBus.$off('getBoardFixData');
  },
  destroyed() {},
  computed: {},
  methods: {
    initConfig() {
      let boardTemplateConfig = this.returnBoardTemplateConfig(this.boardType);
      this.listLayout = boardTemplateConfig.listLayout;
      this.filterLayout = boardTemplateConfig.filterLayout;
      this.paginationLayout = boardTemplateConfig.paginationLayout;
      let boardFilterConfig = this.returnBoardFilterConfig(this.boardType);
      this.listApiParamSet = boardFilterConfig.listApiParamSet;
      this.paginationType = boardFilterConfig.paginationType;
      this.getFunc = boardFilterConfig.getFunc;
      this.deleteFunc = boardFilterConfig.deleteFunc;
      this.deleteApiParamsSet = boardFilterConfig.deleteApiParamsSet;
      this.deleteSuccessType = boardFilterConfig.deleteSuccessType;
      this.deleteFailTypes = boardFilterConfig.deleteFailTypes;
      this.keyName = boardFilterConfig.keyName;
      this.parsingData = boardFilterConfig.parsingData;
      this.getFixData();
    },
    getFixData(){
      this.$api.$board[this.getFunc](this.listApiParamSet).then(res => res.Data.Result).then(res=>{
        if(res.Info.type != 1){
          this.createAlert({
            title: '',
            content: '데이터를 불러올 수 없습니다.',
            btnText: '확인',
            hide: () => {
              this.$router.back();
            }
          });
          return;
        }
        if(!util.isEmpty(res.List)){
          this.fixBoard = res.List[0];
          this.hasFixBoard = 1;
          this.bidData = this.fixBoard.bn_idx;
        }else{
          this.fixBoard = null;
          this.hasFixBoard = 0;
          this.bidData = '';
        }
      });
    },

    openSelectItem(){
      this.$modal.show('item-one-select-modal', {boardType : this.modalType, emitName: `${this.boardType}setSelectOneModalData` });

    },
    selectFixData(fixData){
      this.fixBoard = fixData.fixBoard
      this.hasData();
      EventBus.$emit('setSelectOneModalDataBtn',this.fixBoard)
    },
    returnUpdateDate(update){
      if(typeof update === "number"){
        return this.returnDateUnix(update);
      }else{
        return '-'
      }
    },
    hasData(){
      if(!util.isEmpty(this.fixBoard)){
        this.hasFixBoard = 1;
      }else{
        this.hasFixBoard = 0;
      }
    },
    changeFixType(){
        // if(this.hasFixBoard == 0){
        //   this.fixBoard = null;
        //   this.bidData = '';
        // }
    }
  },
  watch: {
  },
};
</script>

<style scoped></style>
